<div [attr.title]="question.panelNextText" (click)="nextPanelClick()" [class]="question.getNextButtonCss()">
  <svg [iconName]="question.cssClasses.progressBtnIcon" [size]="'auto'" sv-ng-svg-icon></svg>
</div>